import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSliders = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.42627 11.5C6.42627 10.9477 6.87398 10.5 7.42627 10.5H11.4263V12.5H7.42627C6.87398 12.5 6.42627 12.0523 6.42627 11.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.42627 20.5C6.87398 20.5 6.42627 20.9477 6.42627 21.5C6.42627 22.0523 6.87398 22.5 7.42627 22.5H19.4263V20.5H7.42627Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4263 20.5V22.5H25.4263C25.9786 22.5 26.4263 22.0523 26.4263 21.5C26.4263 20.9477 25.9786 20.5 25.4263 20.5H21.4263Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4263 10.5V12.5L25.4263 12.5C25.9786 12.5 26.4263 12.0523 26.4263 11.5C26.4263 10.9477 25.9786 10.5 25.4263 10.5L13.4263 10.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.4263 11.5C15.4263 13.1569 14.0831 14.5 12.4263 14.5C10.7694 14.5 9.42627 13.1569 9.42627 11.5C9.42627 9.84315 10.7694 8.5 12.4263 8.5C14.0831 8.5 15.4263 9.84315 15.4263 11.5ZM13.4263 11.5C13.4263 12.0523 12.9786 12.5 12.4263 12.5C11.874 12.5 11.4263 12.0523 11.4263 11.5C11.4263 10.9477 11.874 10.5 12.4263 10.5C12.9786 10.5 13.4263 10.9477 13.4263 11.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.4263 21.5C23.4263 23.1569 22.0831 24.5 20.4263 24.5C18.7694 24.5 17.4263 23.1569 17.4263 21.5C17.4263 19.8431 18.7694 18.5 20.4263 18.5C22.0831 18.5 23.4263 19.8431 23.4263 21.5ZM21.4263 21.5C21.4263 22.0523 20.9786 22.5 20.4263 22.5C19.874 22.5 19.4263 22.0523 19.4263 21.5C19.4263 20.9477 19.874 20.5 20.4263 20.5C20.9786 20.5 21.4263 20.9477 21.4263 21.5Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgSliders);
export default ForwardRef;
